import { SVGProps } from "react";

const SvgTelescopeIcon = ({
  isHarbour,
  ...props
}: SVGProps<SVGSVGElement> & { isHarbour?: boolean }) => (
  <svg
    width="99"
    height="100"
    viewBox="0 0 99 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke={isHarbour ? "#0BA5EC" : "#F63D68"}
    strokeWidth="3"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="m41.514 52.056-25.497 5.435a3.857 3.857 0 0 1-4.583-2.9l-2.218-8.882a4.425 4.425 0 0 1 2.857-5.23l55.665-18.303" />
    <path d="m55.928 48.97 17.867-3.808" />
    <path d="m67.2 88.5-12.8-25.6" />
    <path d="M69.154 24.482a8.243 8.243 0 0 1 6-9.993l4.5-1.124a4.12 4.12 0 0 1 4.992 2.998l6.243 24.971a4.12 4.12 0 0 1-2.996 4.993l-4.5 1.124a8.243 8.243 0 0 1-9.994-6z" />
    <path d="m25.861 35.666 4.592 18.373" />
    <path d="m33.6 88.5 12.8-25.6" />
    <circle cx="49.5" cy="54.5" r="8.3" />
  </svg>
);

export default SvgTelescopeIcon;
